<template>
  <div class="stockApp">
    <div class="stock">
      <Header></Header>
      <main>
        <div class="mainBottom">
          <!-- 左侧菜单栏 -->
          <div class="pharmaLeft_Box" v-if="showBox">
            <leftNav
              v-show="collapse"
              :leftCurrentNode="leftCurrentNode"
              :default_expanded="default_expanded"
              :navData="navData"
            ></leftNav>
            <div class="title-img" @click="collapseChage">
              <img v-if="collapse" src="../../assets/img/sq.png" alt />
              <img v-else src="../../assets/img/zk.png" alt style="margin:0" />
              <!-- <i v-if="collapse" class="el-icon-d-arrow-left"></i> -->
              <!-- <i v-else class="el-icon-d-arrow-right"></i> -->
            </div>
          </div>
          <!-- 右侧内容 -->

          <router-view :collapse='collapse'></router-view>
        </div>
      </main>
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
import leftNav from "@/components/leftNav";
import api from "@/../static/common/api/api.js";

export default {
  props: {},
  components: {
    Header,
    Footer,
    leftNav
  },
  data() {
    return {
      collapse: true, //隐藏导航
      leftCurrentNode: 10, //导航默认选中
      showBox: true,
      default_expanded: [0, 3],
      navData: [
        {
          id: 0,
          label: "医药行业",
          children: [
            {
              id: 3,
              label: "化学制剂",
              children: [
                {
                  id: 10,
                  path: "/pharma/chemicalMajor",
                  label: "化学药品制剂主要品种产量"
                },
                {
                  id: 11,
                  path: "/pharma/midbody",
                  label: "化学制药中间体品种产量、出口量"
                },
                {
                  id: 12,
                  path: "/pharma/twentyFour",
                  label: "化学原料药二十四大类品种产量、出口量"
                }
              ]
            },
            {
              id: 4,
              label: "中药生物制剂",
              children: [
                {
                  id: 13,
                  path: "ChineseMedicine",
                  label: "中药生物制药主要品种产量"
                }
              ]
            },
            {
              id: 5,
              label: "医疗器械",
              children: [
                {
                  id: 14,
                  path: "/pharma/instrument",
                  label: "医药器械主要品种产量"
                },
                {
                  id: 15,
                  path: "/pharma/thirdly",
                  label: "NMPA批准的境内第三类医疗器械"
                }
              ]
            },
            {
              id: 6,
              label: "批准新药情况",
              children: [
                {
                  id: 16,
                  path: "/pharma/newDrugs",
                  label: "批准新药"
                }
              ]
            },
            {
              id: 7,
              label: "医药企业情况",
              children: [
                {
                  id: 17,
                  path: "/pharma/DrugForm",
                  label: "医药企业名录"
                },
                {
                  id: 18,
                  path: "/pharma/standard",
                  label: "通过《药品生产质量管理规范》认证的企业"
                },
                {
                  id: 19,
                  path: "/pharma/international",
                  label: "通过制剂国际认证的企业"
                }
              ]
            },
            {
              id: 8,
              label: "医院用药情况",
              children: [
                {
                  id: 20,
                  path: "/pharma/emphasis",
                  label: "主要城市重点医院用药品种金额排序"
                }
              ]
            },
            {
              id: 9,
              label: "医药进出口",
              children: [
                {
                  id: 21,
                  path: "/pharma/tradingSum",
                  label: "进出口金额"
                },
                {
                  id: 22,
                  path: "/pharma/tradingAmount",
                  label: "进出口数量"
                }
              ]
            }
          ]
        },
        {
          id: 1,
          path: "/customs",
          label: "海关企业(停)"
        },
        {
          id: 2,
          path: "/industrial",
          label: "海关企业(停)"
        }
      ]
    };
  },
  computed: {},
  watch: {
    "$route.path": function(n, o) {
      if (n == "/enterprisesDetail") {
        if (sessionStorage.getItem("companyName")) {
          this.showBox = false;
        }
      } else {
        this.showBox = true;
      }
    }
  },
  // watch: {
  //   "$route.path": function(n, o) {
  //     if (n == "/pharma/customs") {
  //       this.leftCurrentNode = 1;
  //     } else if (n == "/pharma/industrial") {
  //       this.leftCurrentNode = 2;
  //     } else if (n == "/pharma/chemicalMajor") {
  //       this.leftCurrentNode = 10;
  //     }
  //   }
  // },
  methods: {
    collapseChage() {
      this.collapse = !this.collapse;
    }
  },
  created() {},
  mounted() {},
};
</script>
<style scoped lang="less">
@import "../../assets/less/tableScrollbar.less";

.stockApp {
  display: flex;
  background: url("../../assets/img/bg.png") no-repeat top;
}
.stock {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
main {
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  // background: #adadb15b;
  .mainTop {
    display: flex;
    .underHeader {
      display: inline-block;
      height: 54px;
      line-height: 54px;
      padding-left: 19px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #dfecf7;
      img {
        width: 12px;
        height: 16px;
      }
    }
    /deep/ .el-breadcrumb__inner {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #dfecf7;
    }
  }
  .mainBottom {
    width: 100%;
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
  }
}
.pharmaLeft_Box {
  display: flex;
}
.title-img {
  img {
    width: 16px;
    height: 54px;
    margin: auto;
    margin-right: 23px;
    margin-left: -16px;
    z-index: 99;
    position: relative;
    // top:50%;
  }
}
</style>
 


// WEBPACK FOOTER //
// src/view/pharma/index.vue